import type { SVGProps } from "react";
export interface DiscordIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function DiscordIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: DiscordIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M15.165 2.887c1.386.205 2.947.566 4.252 1.375 1.356.84 2.406 2.15 2.722 4.11l.088.496c.096.507.218 1.052.347 1.648.167.776.34 1.62.447 2.47.208 1.671.185 3.57-.85 5.178-1.285 1.995-3.31 2.459-4.851 2.915-.472.139-.98-.044-1.254-.451L14.09 17.69l-.06-.1a1.125 1.125 0 0 1 1.859-1.247l.069.092 1.508 2.246c1.303-.399 2.182-.755 2.813-1.735.599-.93.697-2.169.508-3.682-.093-.743-.248-1.503-.414-2.274-.163-.752-.341-1.54-.457-2.26-.202-1.254-.827-2.023-1.685-2.555-.657-.407-1.462-.679-2.347-.871l-.231 1.155q.676.22 1.326.523a1.125 1.125 0 0 1-.96 2.037 9.3 9.3 0 0 0-1.92-.66 9.55 9.55 0 0 0-4.2-.001c-.66.149-1.303.37-1.92.66l-.107.043a1.124 1.124 0 0 1-.853-2.079l.582-.254q.367-.148.742-.269l-.231-1.157c-.884.193-1.689.466-2.345.873-.859.532-1.483 1.301-1.685 2.555-.116.72-.295 1.508-.457 2.26-.166.77-.322 1.53-.414 2.274-.19 1.513-.091 2.752.508 3.682.63.98 1.509 1.337 2.81 1.735l1.511-2.246.07-.092A1.124 1.124 0 0 1 9.91 17.69l-1.975 2.938c-.274.407-.782.59-1.254.45-1.445-.427-3.315-.86-4.602-2.557l-.25-.357C.795 16.556.77 14.657.98 12.985c.106-.849.28-1.693.447-2.47.171-.794.331-1.498.435-2.142l.069-.36c.38-1.764 1.381-2.963 2.653-3.75 1.305-.81 2.866-1.171 4.252-1.376l.22-.01c.505.024.946.388 1.049.902l.436 2.188c.969-.12 1.95-.12 2.918 0l.438-2.188.065-.21c.193-.467.685-.759 1.204-.682"
      />
      <path
        fill={color}
        d="M16.02 15.482a1.125 1.125 0 0 1 .959 2.036 11.76 11.76 0 0 1-9.363.26l-.595-.26-.101-.054a1.125 1.125 0 0 1 .952-2.026l.107.044.479.21a9.5 9.5 0 0 0 7.563-.21m-7.88-4.6a1.375 1.375 0 1 1-1.507 1.51l-.008-.141.008-.141a1.375 1.375 0 0 1 1.366-1.235zm8.001 0a1.375 1.375 0 1 1-1.509 1.51l-.007-.141.007-.141A1.375 1.375 0 0 1 16 10.875z"
      />
    </svg>
  );
}
